// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';

import style from './FeatureSelect.scss';

import type { Node } from 'react';

type Props = {
  children: Node;
};

export default class FeatureSelect extends Component<Props> {

  render() {

    return (
      <section className={style.featureSelect}>
        {this.props.children}
      </section>
    );
  }
}

FeatureSelect.propTypes = {};



// WEBPACK FOOTER //
// ./src/modules/custom-products/components/FeatureSelect/FeatureSelect.jsx